import {
  AppLayout,
  AppLayoutProps,
  Box,
  ColumnLayout,
  Container,
  ContentLayout,
  Grid,
  Header,
  Link,
  SpaceBetween,
  TextContent,
  Badge,
  Button,
  Tabs,
} from "@cloudscape-design/components";
import { Mode } from "@cloudscape-design/global-styles";
import { useEffect, useState, useContext } from "react";
import { GlobalContext, ContentContext } from "../../../context";
import { useNavigate, useLocation } from "react-router-dom";
import { navigateFn } from "../../../routingHelper";
import SeriesNav from "../../../components/series-navbar/series-nav";
import GetSeriesContent from "../get-series-content";
import Rules from "./rules";
import Gallery from "./gallery";
import Series from "./series";
import Register from './register';
import Results from "./results";
import Calendar from "./calendar";
import DriversAndTeams from "./teams";
import Stats from "./stats";


export default function F4A_Series() {
  const { 
    theme, setTheme, 
    activeHref, setActiveHref,
    density, setDensity,
    activeSeriesSection, setActiveSeriesSection,
    seriesContent, setSeriesContent,
  } = useContext(GlobalContext);
  const [activeTabId, setActiveTabId] = useState("series");

  const Content =  () => {
    const rulesHref = {
      Series: "", 
      Results: "",
      Calendar: "",
      Rules: "", 
      Drivers: "", 
      Teams: "",
      Livery: "",
      Stats: "", 
    };

    return (
      <>
      </>
    )
  }

  return (
    <>
      <center>
        <div className="body-content">
          <ContentLayout
            header={
              <div className="series-header-container">
                <img 
                  className="series-header-img"
                  src={theme === Mode.Light ? "/images/f4a/f4a-header-light.png" : "/images/f4a/f4a-header-light.png"}
                  alt="F4A Logo"
                />
              </div>
            }
          >
            
            <Container>
              <SeriesNav />
            </Container>
          </ContentLayout>
        </div>
        <div style={{
          marginTop: "50px",
          maxWidth: "2100px",
        }}> 
          {GetSeriesContent(seriesContent, Series, Results, Calendar, Rules, DriversAndTeams, Stats, Gallery, Register, Results )}
        </div>
      </center>
    </>    
  );
}
